module.exports = __webpack_public_path__ + "img/dashboard-up.6736998c.svg";